<template>
	<div style="height: 100%;">
		<div style="height: 100%;" class="overflow">
			<div style="padding: 0 220px 20px;">
				<div class="list_box" v-for="(item, index) in count" :key="index" infinite-scroll-disabled="disabled">
					<div :v-html="MathJax.MathQueue(item)"></div>
					<div class="type_size_22" v-html="item.title"></div>
					<div  v-if="item.question_type == 6">
						<div class="p_m_t_20"  v-for="(val,key) in item.affiliation" :key="key">
							<div class="type_size_20">
								{{key+1}}:
							</div>
							<div style="margin-top: 10px; font-size: 18px;" v-html="val.name"></div>
						</div>
					</div>
					<div  v-if="item.question_type == 2">
						<div class="p_m_t_20"  v-for="(val,key) in item.affiliation" :key="key">
							<div class="type_size_20">
								{{val.name}}
							</div>
					      <div style="margin-top: 10px; font-size: 18px;" v-html="val.text"></div>
						</div>
					</div>
					<div  v-if="item.question_type == 1">
						<div class="p_m_t_20"  v-for="(val,key) in item.affiliation" :key="key">
							<div class="type_size_20">
								{{val.name}}
							</div>
					      <div style="margin-top: 10px; font-size: 18px;" v-html="val.text"></div>
						</div>
					</div>
					<div class="p_m_t_20 type_size_18" v-html="'解析：' + item.analysis">
					</div>
					<div class="p_flex p_f_a p_f_b p_m_t_20">
						<div class="p_flex type_size_16">
							<span class="subject_color">{{ item.grade_def }}</span>
							<el-divider direction="vertical"></el-divider>
							<span class="subject_yellow">{{ item.subject_def }}</span>
							<el-divider direction="vertical"></el-divider>
							<span>{{ item.question_type_def }}</span>
							<el-divider direction="vertical"></el-divider>
							<span>{{ item.score }}分</span>
						</div>
						<div class="p_flex"><el-button @click="godelete(item.id)" style="color: #999999;font-size: 12px;" type="info" plain size="mini">删除</el-button></div>
						<!-- <div class="p_flex">
							<el-checkbox-group v-model="checkedCities" @change="change">
								<el-checkbox :label='item.id' :checked='ids.indexOf(item.id+"")>=0' >{{""}}</el-checkbox>
							</el-checkbox-group>
						</div> -->
					</div>
				</div>
			</div>
			<!-- <pagination @get="get" :index="num"/> -->
		</div>
	</div>
</template>

<script>
import pagination from '../../../pagination/pagination.vue';
export default {
	props: {
		dataInfo: Object,
		ids: Array
	},
	data() {
		return {
			count: [],
			num: 0,
			page: 1,
			checkedCities: []
		};
	},
	watch: {},
	components: {
		pagination
	},
	created() {
		if (this.ids.length != 0) {
			this.getPag();
		}
	},
	mounted() {},
	methods: {
		get(i) {
			this.page = i;
			this.getPag();
		},
		getPag() {
			this.$request
				.ajax(this)
				.post('/api_teacher/question_list', {
					ids: this.ids
				})
				.then(res => {
					this.count = res.data.list;
					this.num = res.data.count;
				});
		},
		godelete(id) {
			this.$emit('godelete', id);
		},
		change(e) {
			this.$emit('change', e);
		}
	}
};
</script>

<style lang="scss" scoped>
.list_box {
	padding: 20px 0;
	border-bottom: 1px solid #e6e6e6;
	margin: 0 20px;
}
>>> .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
	border-color: #00af63;
	background: #00af63;
}
>>> .el-checkbox__input.is-checked + .el-checkbox__label {
	color: #00af63;
}
>>> .el-checkbox__inner {
	width: 18px;
	height: 18px;
}
>>> .el-checkbox__label {
	font-size: 18px;
}
>>> .el-checkbox__inner:hover {
	border-color: #999999;
}

>>> .el-checkbox__inner::after {
	height: 9px;
	left: 6px;
	top: 1px;
	width: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/homet/exercises/commponents/listone.vue